import { createContext, useContext } from "react";
import {
  AccelContextValues,
} from "../../types/AccelContext";

import dayjs from "dayjs"; 

export const AccelContext = createContext<AccelContextValues>({
  auth: {
    access_token: "",
    expires_at: new Date(2000, 1, 1),
    expires_in: -1,
    token_type: "",
  },
  companyId: "",
  company: undefined,
  categories: [],
  apiUrl: "",
  theme: undefined,
  usePlaidSandbox: true,
  environment: "",
  selectedDate: dayjs(),
  dispatcher: () => {},
  profitandloss: undefined,
  fillerData: false,
  generalLedger: {},
  incomeStatementSheet: {},
  revenueProfitExpense: undefined,
  transactionsByMonth: undefined,
  authErrorState: false,
});

export const useAccelContext = () => useContext(AccelContext);
